// extracted by mini-css-extract-plugin
module.exports = {"wrap":"social-networks-layout_wrap__AAMjW"};